import { createSelector } from 'reselect';
import { OrderedMap } from 'immutable';

import type { TypedMap } from 'utils/typed-map';

import type { State } from '../../reducers';

import Organizer from './model';

interface OrganizersState {
  organizers: OrderedMap<string, Organizer>;
  total?: number;
}

export const selectOrganizersState = (state: State): TypedMap<OrganizersState> =>
  state.get('entities').organizers;

export const selectOrganizers = createSelector(
  selectOrganizersState,
  (organizersState: TypedMap<OrganizersState>): OrderedMap<string, Organizer> =>
    organizersState.get('organizers')
);

export const selectTotal = createSelector(
  selectOrganizersState,
  (organizersState: TypedMap<OrganizersState>): number | undefined => organizersState.get('total')
);

export const selectOrganizerById = createSelector(
  selectOrganizers,
  (_: State, organizerId: string) => organizerId,
  (organizers: OrderedMap<string, Organizer>, organizerId: string): Organizer | undefined =>
    organizers.get(organizerId)
);
